module.exports = __webpack_public_path__ + "img/paci_ar_6.41cfd6ef.png";